/**
 * Reia — WhatsApp chat OTP gate (window.ReiaWhatsAppGate)
 * Moved out of snippets/reia-whatsapp-otp-gate.liquid (was inline on every page) so it is cached between page views.
 */
var REIA_SHOP = window.reiaShopDomain || '';
(function () {
  if (window.ReiaWhatsAppGate) return;

  var SHOP = REIA_SHOP;
  var WA_PHONE = '916360580124';
  var CALL_TEL = '+916360580124';
  var sendUrl   = '/apps/reia-booking/api/otp/send?shop=' + SHOP;
  var verifyUrl = '/apps/reia-booking/api/otp/verify?shop=' + SHOP;
  var leadsUrl  = '/apps/reia-booking/api/leads?shop=' + SHOP;
  // On a product page every gated chat carries the product, wherever the CTA sits.
  var PAGE_PRODUCT = window.reiaWaPageProduct || {};

  var phoneModal = document.getElementById('reia-chat-phone-modal');
  var phoneTitle = document.getElementById('reia-chat-phone-title');
  var phoneSubtitle = document.getElementById('reia-chat-phone-subtitle');
  var sendLabel  = document.getElementById('reia-chat-send-label');
  var otpModal   = document.getElementById('reia-chat-otp-modal');
  var phoneEl    = document.getElementById('reia-chat-phone');
  var phoneErr   = document.getElementById('reia-chat-phone-error');
  var sendBtn    = document.getElementById('reia-chat-send-btn');
  var otpInput   = document.getElementById('reia-chat-otp-input');
  var otpErr     = document.getElementById('reia-chat-otp-error');
  var verifyBtn  = document.getElementById('reia-chat-verify-btn');
  var resendBtn  = document.getElementById('reia-chat-resend-btn');
  var otpSubtitle= document.getElementById('reia-chat-otp-subtitle');
  var successModal = document.getElementById('reia-chat-success-modal');
  var successTitle = document.getElementById('reia-chat-success-title');
  var successText  = document.getElementById('reia-chat-success-text');
  var continueBtn  = document.getElementById('reia-chat-continue-btn');
  var redirectNote = document.getElementById('reia-chat-redirect-note');
  if (!phoneModal || !otpModal || !successModal) return;

  // Flow mode: 'chat' (→ WhatsApp) or 'callback' (→ tel:)
  var mode = 'chat';
  // Context of the CTA that opened the gate (where to redirect + what to log)
  var ctx = {};
  var PHONE_COPY = {
    chat: {
      title: 'Chat with Us on WhatsApp',
      subtitle: "Enter your WhatsApp number and we'll connect you with our jewellery expert."
    },
    callback: {
      title: 'Request a Call Back',
      subtitle: "Enter your number and our jewellery expert will call you back shortly."
    }
  };
  var PHONE_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.24.2 2.45.57 3.57a1 1 0 01-.24 1.01l-2.2 2.2z"/></svg>';

  var otpPhone = '';
  var timer = null;
  var redirectTimer = null;
  var countdownTimer = null;

  // Move modals to <html> so no ancestor stacking context clips them
  [phoneModal, otpModal, successModal].forEach(function (m) {
    if (m && m.parentNode !== document.documentElement) document.documentElement.appendChild(m);
  });

  // Input is the 10-digit local number only; +91 is shown as a fixed prefix.
  function normalizePhone(raw) {
    return '+91' + (raw || '').replace(/\D/g, '').slice(-10);
  }
  function isValidPhone(raw) {
    var d = (raw || '').replace(/\D/g, '');
    return d.length === 10 && /^[6-9]/.test(d);
  }
  function closeAll() {
    phoneModal.classList.remove('active');
    otpModal.classList.remove('active');
    successModal.classList.remove('active');
    clearInterval(timer);
    clearInterval(countdownTimer);
    clearTimeout(redirectTimer);
  }
  function startTimer() {
    var secs = 60;
    resendBtn.disabled = true;
    resendBtn.textContent = 'Resend in ' + secs + 's';
    clearInterval(timer);
    timer = setInterval(function () {
      secs--;
      resendBtn.textContent = secs > 0 ? 'Resend in ' + secs + 's' : 'Resend code';
      if (secs <= 0) { clearInterval(timer); resendBtn.disabled = false; }
    }, 1000);
  }
  function openOtpModal() {
    var d = otpPhone.replace('+91', '');
    otpSubtitle.textContent = 'We sent a 6-digit code to +91 ' + d.slice(0,5) + ' ' + d.slice(5) + ' on WhatsApp.';
    otpInput.value = '';
    otpErr.textContent = '';
    phoneModal.classList.remove('active');
    otpModal.classList.add('active');
    setTimeout(function () { otpInput.focus(); }, 100);
    startTimer();
  }

  // Default chat target when the CTA didn't bring its own WhatsApp link.
  function defaultWhatsappUrl() {
    var url = encodeURIComponent(window.location.href);
    var msg = 'Hello,%0AI would like to know more about this product.%0A' + url +
              '%0ACould you please give me further details?%0AThank You!';
    return 'https://api.whatsapp.com/send?phone=' + WA_PHONE + '&text=' + msg;
  }

  function leadType()    { return mode === 'callback' ? 'request_callback' : 'whatsapp_chat'; }
  function leadSource()  { return ctx.source || (mode === 'callback' ? 'pdp_request_callback' : 'pdp_chat_with_us'); }
  function verifyLabel() { return mode === 'callback' ? 'Verify & Call' : 'Verify & Chat'; }

  // Route by mode.
  function showSuccessAndRedirect() {
    phoneModal.classList.remove('active');
    otpModal.classList.remove('active');

    if (mode === 'callback') {
      // Callback: capture is the value; team will call back. Show confirmation with
      // a tap-to-call button (works on mobile; on desktop it shows the number).
      successModal.classList.add('active');
      successTitle.textContent = 'Request received!';
      successText.innerHTML = "Thank you — our jewellery expert will call you back shortly on your number. " +
        "Prefer to talk now? Call us on <strong>+91 63605 80124</strong>.";
      continueBtn.innerHTML = PHONE_ICON + '<span>Call us now</span>';
      redirectNote.textContent = '';
      continueBtn.onclick = function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'pdp_request_callback_callnow_clicked' });
        window.location.href = 'tel:' + CALL_TEL;
      };
      return;
    }

    // Chat: redirect to WhatsApp immediately (no confirmation screen / timer).
    window.location.href = ctx.waUrl || defaultWhatsappUrl();
  }

  // Variant currently selected on the PDP (the product form's hidden id input,
  // else ?variant= in the URL) — render-time data attributes go stale on change.
  function liveVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return String(input.value);
    try { return new URL(window.location.href).searchParams.get('variant') || ''; } catch (e) { return ''; }
  }
  // The message the customer is about to send, and to which number.
  function waDetails(url) {
    try {
      var u = new URL(url);
      var number = u.hostname.replace(/^www\./, '') === 'wa.me' ? u.pathname.replace(/\D/g, '') : (u.searchParams.get('phone') || '').replace(/\D/g, '');
      return { message: (u.searchParams.get('text') || '').slice(0, 1500), number: number };
    } catch (e) { return { message: '', number: '' }; }
  }

  function captureLead() {
    var sessionId = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : Date.now().toString(36) + Math.random().toString(36).slice(2);
    // window.reiaGetClickAttribution comes from reia-click-id-tracking.js
    // (assets/reia-click-id-tracking.js), loaded site-wide in <head>.
    var attribution = window.reiaGetClickAttribution ? window.reiaGetClickAttribution() : null;
    var metadata = {};
    if (attribution) for (var k in attribution) metadata[k] = attribution[k];
    if (ctx.ctaLabel) metadata.cta_label = ctx.ctaLabel;
    metadata.page_title = document.title;
    if (ctx.store) metadata.store = ctx.store;
    if (mode === 'chat') {
      var wa = waDetails(ctx.waUrl || defaultWhatsappUrl());
      if (wa.message) metadata.wa_message = wa.message;
      if (wa.number) metadata.wa_number = wa.number;
    }
    metadata.device = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop';
    var variantId = ctx.variantId || (PAGE_PRODUCT.variants ? liveVariantId() : '');
    var variantInfo = PAGE_PRODUCT.variants && PAGE_PRODUCT.variants[variantId];
    if (variantInfo && variantInfo[0] !== 'Default Title') metadata.variant_title = variantInfo[0];
    var payload = {
      session_id: sessionId,
      phone: otpPhone,
      form_type: leadType(),
      source: leadSource(),
      product_title: ctx.productTitle || PAGE_PRODUCT.title || '',
      product_url: ctx.productUrl || PAGE_PRODUCT.url || window.location.pathname,
      variant_id: variantId || '',
      variant_price: ctx.variantPrice || (variantInfo ? variantInfo[1] : ''),
      page_url: window.location.href,
      metadata: metadata
    };
    // Fire-and-forget: never block opening WhatsApp on lead capture.
    try {
      fetch(leadsUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  // ── Open phone modal for a given flow ──
  function open(opts) {
    opts = opts || {};
    closeAll();
    mode = opts.mode === 'callback' ? 'callback' : 'chat';
    ctx = opts;
    var copy = PHONE_COPY[mode];
    phoneTitle.textContent = copy.title;
    phoneSubtitle.textContent = copy.subtitle;
    verifyBtn.textContent = verifyLabel();
    verifyBtn.disabled = false;
    phoneErr.textContent = '';
    phoneModal.classList.add('active');
    setTimeout(function () { phoneEl.focus(); }, 100);
  }

  // ── Gate direct WhatsApp links site-wide ──
  // Only links that message a number (wa.me/<digits>, …/send?phone=…); share
  // links like api.whatsapp.com/send?text=… have no phone and pass through.
  function isDirectChatLink(href) {
    var u;
    try { u = new URL(href, window.location.href); } catch (e) { return false; }
    var host = u.hostname.replace(/^www\./, '');
    if (host === 'wa.me') return /^\/\+?\d{6,}/.test(u.pathname);
    if (u.protocol === 'whatsapp:' || host === 'api.whatsapp.com' || host === 'web.whatsapp.com') {
      return /\d{6,}/.test(u.searchParams.get('phone') || '');
    }
    return false;
  }
  function ctaLabelOf(el) {
    var t = (el.getAttribute('aria-label') || el.textContent || el.getAttribute('title') || '').replace(/\s+/g, ' ').trim();
    return t.slice(0, 120);
  }
  // Capture phase on window so it runs before any other click handler
  // (page transitions, section scripts) can follow the link.
  window.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.hasAttribute('data-reia-wa-direct')) return;
    // The booking app widget runs its own OTP before showing its "Open WhatsApp"
    // link — don't ask the customer to verify twice.
    if (a.closest('[data-reia-booking-drawer]')) return;
    if (!isDirectChatLink(a.getAttribute('href'))) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open({
      mode: 'chat',
      waUrl: a.href,
      source: a.getAttribute('data-reia-wa-source') || 'site_whatsapp_link',
      ctaLabel: ctaLabelOf(a),
      store: a.getAttribute('data-reia-wa-store') || ''
    });
  }, true);

  // ── Close buttons + backdrop ──
  document.querySelectorAll('[data-reia-chat-close]').forEach(function (b) {
    b.addEventListener('click', closeAll);
  });
  [phoneModal, otpModal, successModal].forEach(function (m) {
    m.addEventListener('click', function (ev) { if (ev.target === m) closeAll(); });
  });

  // Restrict to digits, max 10
  phoneEl.addEventListener('input', function () {
    this.value = this.value.replace(/\D/g, '').slice(0, 10);
    if (phoneErr.textContent) phoneErr.textContent = '';
  });
  phoneEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') sendBtn.click(); });

  // ── Send OTP ──
  async function sendOtp() {
    var res = await fetch(sendUrl, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: otpPhone })
    }).then(function (r) { return r.json(); });
    return res;
  }

  sendBtn.addEventListener('click', async function () {
    phoneErr.textContent = '';
    if (!isValidPhone(phoneEl.value)) {
      phoneErr.textContent = 'Please enter a valid 10-digit number.';
      return;
    }
    otpPhone = normalizePhone(phoneEl.value);

    sendBtn.disabled = true;
    sendLabel.textContent = 'Sending…';
    try {
      var res = await sendOtp();
      if (res && res.success) {
        openOtpModal();
      } else {
        phoneErr.textContent = (res && res.error) || 'Unable to send code. Please try again.';
      }
    } catch (e) {
      phoneErr.textContent = 'Unable to send code. Please try again.';
    }
    sendBtn.disabled = false;
    sendLabel.textContent = 'Send code';
  });

  // ── Resend ──
  resendBtn.addEventListener('click', async function () {
    resendBtn.disabled = true;
    otpErr.textContent = '';
    try {
      var res = await sendOtp();
      if (res && res.success) { otpInput.value = ''; startTimer(); }
      else { otpErr.textContent = (res && res.error) || 'Unable to resend.'; resendBtn.disabled = false; }
    } catch (e) { otpErr.textContent = 'Unable to resend.'; resendBtn.disabled = false; }
  });

  // ── OTP input + verify ──
  otpInput.addEventListener('input', function () { this.value = this.value.replace(/\D/g, '').slice(0, 6); });
  otpInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') verifyBtn.click(); });

  verifyBtn.addEventListener('click', async function () {
    var code = otpInput.value.trim();
    if (code.length !== 6) { otpErr.textContent = 'Please enter the 6-digit code.'; return; }
    otpErr.textContent = '';
    verifyBtn.disabled = true;
    verifyBtn.textContent = 'Verifying…';
    try {
      var res = await fetch(verifyUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: otpPhone, code: code })
      }).then(function (r) { return r.json(); });
      if (res && res.success) {
        captureLead();
        showSuccessAndRedirect();
      } else {
        otpErr.textContent = (res && res.error) || 'Incorrect code. Please try again.';
        verifyBtn.disabled = false;
        verifyBtn.textContent = verifyLabel();
      }
    } catch (e) {
      otpErr.textContent = 'Verification failed. Please try again.';
      verifyBtn.disabled = false;
      verifyBtn.textContent = verifyLabel();
    }
  });

  window.ReiaWhatsAppGate = { open: open };
})();
